const { is } = require('../../is/is')

/**
 * A megadott érték dátum?
 * @param {unknown} value - Az ismeretlen érték.
 * @returns {boolean} Érvényes dátum?
 */
module.exports.isValidDate = function isValidDate (value) {
  if (!is.string(value)) {
    return false
  }

  const d = new Date(value)

  const isValid = !Number.isNaN(d.getTime())

  return isValid
}
